module.exports = __webpack_public_path__ + "img/1-fr.cbf49040.jpg";